import { render, staticRenderFns } from "./PaymentDetailsCard.vue?vue&type=template&id=b83cdb0e&scoped=true"
import script from "./PaymentDetailsCard.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetailsCard.vue?vue&type=style&index=0&id=b83cdb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83cdb0e",
  null
  
)

export default component.exports